export default "__VITE_ASSET__ObtQ3sDg__"